import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DataService } from '../../_services';
import { CurrencyDisplayService } from '../../_services/currency-display.service';

@Component({
  selector: 'app-app-currency-display',
  templateUrl: './app-currency-display.component.html',
  styleUrls: ['./app-currency-display.component.scss'],
})
export class AppCurrencyDisplayComponent implements OnInit {
  @Input() amtDetails = { dispalyStr: '', amts: [{ amt: 0, curr: 'USD', formattedAmt: '' }] };
  @Input() options = {};
  amtDisplayStr = '';
  constructor() { }

  ngOnInit() {
  }



}
